'use client';

import { cn } from '@/shared/utils/tw';
import type { Toast } from '../types/toast-types';

interface ToastSTTProps {
  toast: Toast;
}

/**
 * Toast-STT: 사용자 음성 인식 자막 토스트
 */
export const ToastSTT = ({ toast }: ToastSTTProps) => (
  <div
    className={cn(
      'rounded-[16px]',
      'px-[18px] py-[10px]',
      'font-pretendard text-[15px] font-medium text-black text-center leading-[1.4] break-keep',
      'pointer-events-auto',
      'max-w-[85cqw]',
      toast.isExiting ? 'animate-toast-exit' : 'animate-toast-enter'
    )}
    style={{
      background: 'rgba(255, 255, 255, 0.35)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      border: '1.5px solid rgba(255, 255, 255, 0.15)',
    }}
  >
    {toast.message}
  </div>
);
